export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10727.202d4d82.jpg";